import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import { autobind } from 'core-decorators';
import withWhereabouts from './with-whereabouts';
/**
 * HoC that checks for hash in URL and tries to render to element with that ID
 * on `componentDidMount` and `componentWillReceiveProps` if the hash changed!
 * @param  {string} scrollParentId
 * @param  {Number} buffer
 * @return {class}
 */

export default function scrollable(scrollParentId) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
  return function (WrappedComponent) {
    var _dec, _class;

    var Scrollable = (_dec = withWhereabouts(), _dec(_class = autobind(_class = /*#__PURE__*/function (_PureComponent) {
      _inherits(Scrollable, _PureComponent);

      var _super = _createSuper(Scrollable);

      function Scrollable() {
        _classCallCheck(this, Scrollable);

        return _super.apply(this, arguments);
      }

      _createClass(Scrollable, [{
        key: "scrollTo",
        value: // Scroll to element if it exists
        // TODO: scroll container not window when `scrollParentId` is defined!
        function scrollTo(elementId) {
          var element = window.document.getElementById(elementId);

          if (!element) {
            return null;
          }

          window.scrollTo(0, element.getBoundingClientRect().top - buffer);
        } // Everything is rendered, so we can check for the hash now

      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          var whereabouts = this.props.whereabouts;
          this.scrollTo(whereabouts.hash);
        } // Check if the hash changed, if so, check if we can scroll to the
        // position requested by the new hash

      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          if (this.props.whereabouts.hash !== nextProps.whereabouts.hash) {
            this.scrollTo(nextProps.whereabouts.hash);
          }
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(WrappedComponent, this.props);
        }
      }]);

      return Scrollable;
    }(PureComponent)) || _class) || _class);
    return Scrollable;
  };
}